import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA + auto-reload on new SW activation so
// users always run the latest deployed JS/CSS bundle.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });

    // When a new SW takes control, the bundle was just updated — reload once
    // to guarantee the in-memory React app matches the new code.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      // Tiny delay so the new SW finishes claiming clients
      setTimeout(() => window.location.reload(), 50);
    });

    // Fallback: SW posts SW_UPDATED on activate — also wipes any stale data.
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SW_UPDATED' && !reloaded) {
        reloaded = true;
        setTimeout(() => window.location.reload(), 50);
      }
    });
  });
}
